import popupReducer from "./popup/Popup";
import auth from "./auth/Auth";
import inquiry from "./inquiry/Inquiry";
import media from "./media/Media";
import agreementReducer from "./agreement/Agreement";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  popupReducer,
  auth,
  inquiry,
  media,
  agreementReducer
});

export default rootReducer;
